import React from 'react'
import { Observable } from 'rxjs'
import { AjaxResponse } from 'rxjs/ajax'
import { getExpenseRegister } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { FinanceApiResponse } from '../../types/finance'
import formatFinanceDate from '../../utils/formatFinanceDate'

const ExpenseRegister = () => {
  const report = useFinanceObservable<any[]>(
    () =>
      getExpenseRegister({}) as any as Observable<
        AjaxResponse<FinanceApiResponse<any[]>>
      >,
  )

  return (
    <ReportTablePage
      title="Expense Register"
      rows={report.data || []}
      isLoading={report.loading}
      columns={[
        { name: 'ID', selector: (row) => row.id || '--' },
        { name: 'Description', selector: (row) => row.description || '--' },
        { name: 'Status', selector: (row) => row.status || '--' },
        {
          name: 'Posting Date',
          selector: (row) =>
            formatFinanceDate(row.posting_date || row.document_date),
        },
        { name: 'Amount', selector: (row) => row.amount_total || 0 },
      ]}
    />
  )
}

export default ExpenseRegister
